/* eslint-disable react/prop-types */
import { Link } from 'react-router-dom';

import { ErrorIcon, Tag, TagLockIcon, TagShareIcon } from '@utilities';

import FastTrackStatus from '../../../../../components/FastTrackStatus';

export const ITEM_COLUMNS = [
  {
    accessor: 'name',
    Cell: ({ row }) => {
      return <Link to={`/dashboard/narrative/${row?.original?.id}`}>{row?.original?.name}</Link>;
    },
    Header: 'Name',
    width: 225,
  },
  {
    accessor: 'type',
    Cell: ({ row }) => {
      return <span title={row?.original?.fastTrackName}>{row?.original?.fastTrackName}</span>;
    },
    Header: 'Type',
    width: 100,
  },
  {
    accessor: 'status',
    Cell: ({ row }) => {
      return (
        <FastTrackStatus
          fastTrack={row?.original}
          showCompleteMessage={true}
          showTruncatedMessage={true}
        />
      );
    },
    disableSortBy: true,
    Header: 'Status',
    width: 100,
  },
  {
    Cell: ({ row }) => {
      return (
        <>
          {row?.original?.isShared && <Tag icon={<TagShareIcon />} tooltip="Shared" />}
          {!row?.original?.isOwner && <Tag icon={<TagLockIcon />} tooltip="Locked" />}
          {row?.original?.hasException && <Tag icon={<ErrorIcon />} tooltip="Failed" />}
        </>
      );
    },
    disableSortBy: true,
    Header: 'Tags',
    width: 100,
  },
  {
    accessor: 'creator',
    Header: 'Creator',
    width: 100,
  },
  {
    accessor: 'created_datetime',
    Cell: ({ row }) => {
      return new Date(row?.original?.createdDateTime).toLocaleDateString('en-us', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      });
    },
    Header: 'Created',
    width: 100,
  },
];

export const FILTER_OPTIONS = [
  {
    label: 'Creator',
    options: [
      {
        label: 'Created by Me',
        value: 'created_by_me_all',
      },
      {
        label: 'Created by Others',
        value: 'created_by_others_all',
      },
    ],
  },
  {
    label: 'Narratives',
    options: [
      {
        label: 'Shared Narrative',
        value: 'is_shared_item',
      },
    ],
  },
];
